export default __webpack_public_path__ + "static/media/all-offer-card2.f76bb029.png";